export enum ProjectTypes {
  LASTEST = 'lastest',
  OUTDATED = 'outdated',
  URBAN = 'urban',
  SPOTLIGHT = 'spotlight',
}

export type ProjectType =
  | ProjectTypes.LASTEST
  | ProjectTypes.OUTDATED
  | ProjectTypes.URBAN
  | ProjectTypes.SPOTLIGHT;

export const projectTypeList = [
  ProjectTypes.LASTEST, ProjectTypes.OUTDATED, ProjectTypes.URBAN, ProjectTypes.SPOTLIGHT,
];
